import { ClassifierFields } from '@dealstack/frontend/app/pages/Project/DealSettings/Classifiers/types';
import { FormField } from '@dealstack/frontend/shared/components/Documents/FormFields/types';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n';
import { DocumentFieldType } from '@dealstack/shared/lib/generated';
import { SearchSelectWithNestedCollapsableChildrenOptions } from '@dealstack/frontend/shared/components/forms/SearchSelectWithNestedCollapsableChildren/SearchSelectWithNestedCollapsableChildren.types';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

export const nameField = (
	tDashBoard: TranslateFunction<I18Namespaces.ADMIN_DASHBOARD>
): FormField => {
	return {
		fieldKey: ClassifierFields.name,
		label: tDashBoard('drawer.field.label.updateName'),
		type: DocumentFieldType.TEXT,
		required: true,
	};
};

export const parentIdField = (
	tDashBoard: TranslateFunction<I18Namespaces.ADMIN_DASHBOARD>,
	options: SearchSelectWithNestedCollapsableChildrenOptions[] = [],
	disabled = false
): FormField => {
	return {
		fieldKey: ClassifierFields.classifierParentId,
		label: tDashBoard('drawer.field.label.updateParentId'),
		type: DocumentFieldType.SELECT,
		options,
		placeholder: tDashBoard('drawer.field.placeHolder.updateParentId'),
		disabled,
	};
};

export const archiveField = (
	tDashBoard: TranslateFunction<I18Namespaces.ADMIN_DASHBOARD>,
	disabled = false
): FormField => {
	return {
		fieldKey: ClassifierFields.archive,
		label: tDashBoard('drawer.field.label.archive'),
		type: DocumentFieldType.BOOLEAN,
		required: true,
		checked: true,
		disabled,
	};
};
